import { render, staticRenderFns } from "./EditUnit.vue?vue&type=template&id=84dab1c0&scoped=true&"
import script from "./EditUnit.vue?vue&type=script&lang=js&"
export * from "./EditUnit.vue?vue&type=script&lang=js&"
import style0 from "./EditUnit.vue?vue&type=style&index=0&id=84dab1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dab1c0",
  null
  
)

export default component.exports